import { EnumScreenName, EventProperties } from '@calm/evexia-analytics';
import commonMessages from '@rhg/lang/messages/common';
import { useTracking } from '@rhg/libs/analytics';
import { InvitationErrorType } from '@rhg/utils/invitations';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { GeneralErrorDialog } from '../general-error-dialog';
import { registrationInvitationErrorMessages } from './messages';

const title: Record<
    InvitationErrorType,
    typeof registrationInvitationErrorMessages.invitationExpiredTitle
> = {
    expired: registrationInvitationErrorMessages.invitationExpiredTitle,
    claimed: registrationInvitationErrorMessages.invitationRedeemedTitle,
    country: registrationInvitationErrorMessages.invitationCountryTitle,
};

const subtitle: Record<
    InvitationErrorType,
    typeof registrationInvitationErrorMessages.invitationExpiredTitle
> = {
    expired: registrationInvitationErrorMessages.subtitle,
    claimed: registrationInvitationErrorMessages.subtitle,
    country: registrationInvitationErrorMessages.invitationCountrySubtitle,
};

export interface InvitationErrorDialogProps {
    type: InvitationErrorType;
    trackScreen?: EnumScreenName;
    trackProps?: EventProperties;
    onClose: () => void;
}
export function InvitationErrorDialog({
    type = 'expired',
    trackScreen,
    trackProps,
    onClose,
}: InvitationErrorDialogProps) {
    const { formatMessage } = useIntl();
    const { track } = useTracking();
    const trackInvitationError = useCallback(() => {
        if (type === 'country') {
            track('RegistrationCountryError', trackProps);
        } else {
            track('DependentRegistrationError', {
                ...(trackProps ? trackProps : {}),
                ErrorType: type,
            });
        }
    }, [track, trackProps, type]);

    return (
        <GeneralErrorDialog
            onOpen={trackInvitationError}
            trackDialog="DependentRegistrationError"
            trackCloseButton="Close"
            trackScreen={trackScreen}
            trackProps={trackProps}
            title={formatMessage(title[type])}
            errorContent={formatMessage(subtitle[type])}
            onClose={onClose}
            showSupportEmail={type === 'country'}
            buttons={
                type === 'country'
                    ? undefined
                    : [
                          {
                              trackButton: 'Close',
                              title: formatMessage(
                                  commonMessages['common.close']
                              ),
                              variant: 'text',
                              onClick: onClose,
                          },
                      ]
            }
        />
    );
}
